import { STLLoader } from 'three/examples/jsm/loaders/STLLoader';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import {
  MeshStandardMaterial,
  Mesh,
  Color,
  Vector3,
  Box3,
  WebGLRenderer,
  Scene,
  PerspectiveCamera,
  AmbientLight,
  DirectionalLight,
  CanvasTexture,
  PlaneGeometry
} from 'three';

const SimpleSTLViewerToImage = async (url) => {
  return new Promise((resolve) => {
    if (!url) {
      return resolve(createFallbackImage());
    }

    const isOBJ = url.toLowerCase().endsWith('.obj');
    const loader = isOBJ ? new OBJLoader() : new STLLoader();

    loader.load(
      url,
      (loadedData) => {
        const geometry = isOBJ ? loadedData.children[0].geometry : loadedData;

        const material = new MeshStandardMaterial({
          color: new Color(0xCCCCCC),
          roughness: 0.5,
          metalness: 0.5,
        });

        const mesh = new Mesh(geometry, material);

        const scene = new Scene();
        scene.background = new Color(0xffffff);
        scene.add(mesh);

        const boundingBox = new Box3().setFromObject(mesh);
        const center = new Vector3();
        boundingBox.getCenter(center);
        mesh.position.sub(center);

        const size = new Vector3();
        boundingBox.getSize(size);
        const maxAxis = Math.max(size.x, size.y, size.z);
        const scaleValue = 10 / maxAxis;
        mesh.scale.set(scaleValue, scaleValue, scaleValue);
        mesh.position.set(
          -center.x * scaleValue,
          -center.y * scaleValue - 2,
          -center.z * scaleValue + 40
        );

        const camera = new PerspectiveCamera(50, 1, 0.1, 1000);
        camera.position.set(0, 0, 50);
        camera.lookAt(0, 0, 0);

        const renderer = new WebGLRenderer({ antialias: true });
        renderer.setSize(500, 500);

        const ambientLight = new AmbientLight(0xffffff, 1);
        scene.add(ambientLight);
        const directionalLight = new DirectionalLight(0xffffff, 1);
        directionalLight.position.set(10, 10, 10);
        scene.add(directionalLight);

        renderer.render(scene, camera);
        const dataURL = renderer.domElement.toDataURL('image/png');
        resolve(dataURL);
      },
      undefined,
      () => {
       
        resolve(createFallbackImage());
      }
    );
  });
};


function createFallbackImage() {
  const canvas = document.createElement('canvas');
  canvas.width = 500;
  canvas.height = 500;
  const ctx = canvas.getContext('2d');

  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  ctx.fillStyle = '#888888';
  ctx.font = '20px Arial';
  ctx.textAlign = 'center';
  ctx.fillText('Image not available', canvas.width / 2, canvas.height / 2);

  return canvas.toDataURL('image/png');
}

export default SimpleSTLViewerToImage;
